/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'none': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" class="st0" d="M27 28.8L.4 2.2C-.1 1.7-.1.9.4.4s1.3-.5 1.8 0L28.8 27c.5.5.5 1.3 0 1.8-.5.6-1.3.6-1.8 0"/><path pid="1" class="st0" d="M.4 28.8c-.5-.5-.5-1.3 0-1.8L27 .4c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8L2.2 28.8c-.5.6-1.3.6-1.8 0"/>'
  }
})
